import FieldsView from '../views/FieldsView';
import FarmLayout from '../layouts/FarmLayout';
import FieldsPreviewView from '../views/FieldsPreviewView';
import {
  ECON_NON_SUBSIDY_VIEWS,
  ECON_SUBSIDY_VIEWS,
  FIELDS_VIEW,
} from '../constants/views';
import BreadcrumbLayout from '../layouts/BreadcrumbLayout';
import { FarmCropsTable } from '../components/templates/CropsTable';
import { cropTabRoutes, FarmCropTabLayout } from '../layouts/CropTabLayout';
import { EditFarmCropSettings } from '../components/templates/EditCropSettings';
import { FarmCapexesTable } from '../components/templates/CapexesTable';
import { EditFarmCapex } from '../components/templates/EditCapex';
import { FarmInputsTable } from '../components/templates/InputsTable';
import { EditFarmInput } from '../components/templates/EditInput';
import { EditFarmFuelPricing } from '../components/templates/EditFuel';
import { FarmLaborTable } from '../components/templates/LaborTable';
import { EditFarmLabor } from '../components/templates/EditLabor';
import AdjustmentsView from '../views/AdjustmentsView';
import SuperadminLayout from '../layouts/SuperadminLayout';
import { SubsidySwitchContextProvider } from '../contexts/SubsidySwitchContext';
import QuoteSummaryView from '../views/QuoteSummaryView';
import OperationsBasisView from '../views/OperationsBasisView';
import InputsView from '../views/InputsView';
import { ASSIGNMENTS } from '../constants/operations';
import CapexBasisView from '../views/CapexBasisView';
import FarmBreadcrumbLayout from '../layouts/FarmBreadcrumbLayout';
import PageLayout from '../layouts/PageLayout';
import OutletLayout from '../layouts/OutletLayout';
import { PatternEditorContextProvider } from '../contexts/PatternEditorContext';
import FarmAuthorizationLayout from '../layouts/FarmAuthorizationLayout';
import FarmIndexView from '../views/FarmIndexView';

const FarmRoutes = {
  path: 'farm/:farmId',
  element: <FarmLayout />,
  children: [
    { index: true, element: <FarmIndexView /> },
    { path: 'map', element: <FieldsView mobileMap /> },
    { path: 'preview', element: <FieldsPreviewView /> },
    {
      element: <PageLayout />,
      children: [
        {
          element: <OutletLayout Component={PatternEditorContextProvider} />,
          children: [FIELDS_VIEW],
        },
        {
          element: <OutletLayout Component={SubsidySwitchContextProvider} />,
          children: ECON_SUBSIDY_VIEWS,
        },
        ...ECON_NON_SUBSIDY_VIEWS,
        {
          path: 'data',
          element: <FarmAuthorizationLayout action="canEdit" />,
          children: [
            {
              path: 'crops',
              element: (
                <FarmBreadcrumbLayout
                  farmPath="data/crops"
                  rootText="Crops"
                  showToggleButtons
                />
              ),
              children: [
                { index: true, element: <FarmCropsTable /> },
                {
                  path: ':id',
                  element: <FarmCropTabLayout />,
                  children: cropTabRoutes({
                    componentAccessor: 'farmComponent',
                    IndexComponent: EditFarmCropSettings,
                  }),
                },
                { path: 'new', element: <EditFarmCropSettings /> },
              ],
            },
            {
              path: 'capexes',
              element: (
                <FarmBreadcrumbLayout
                  farmPath="data/capexes"
                  rootText="CapExes"
                  showToggleButtons
                />
              ),
              children: [
                { index: true, element: <FarmCapexesTable /> },
                { path: 'new', element: <EditFarmCapex /> },
                { path: ':id/edit', element: <EditFarmCapex /> },
              ],
            },
            {
              path: 'inputs',
              element: <BreadcrumbLayout showToggleButtons />,
              children: [
                { index: 'true', element: <FarmInputsTable /> },
                { path: 'new', element: <EditFarmInput /> },
                { path: ':id/edit', element: <EditFarmInput /> },
                { path: 'pricing/new', element: <EditFarmFuelPricing /> },
                { path: 'pricing/:id/edit', element: <EditFarmFuelPricing /> },
              ],
            },
            {
              path: 'labor',
              element: (
                <FarmBreadcrumbLayout
                  farmPath="data/labor"
                  rootText="Labor"
                  showToggleButtons
                />
              ),
              children: [
                { index: true, element: <FarmLaborTable /> },
                { path: ':id/edit', element: <EditFarmLabor /> },
              ],
            },
            {
              path: 'subsidies',
              element: <BreadcrumbLayout showToggleButtons />,
              children: [
                {
                  index: true,
                  element: (
                    <AdjustmentsView
                      adjustmentType="subsidy"
                      pluralAdjustmentType="subsidies"
                      title="Subsidy Settings"
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: 'developer-tools',
          element: <SuperadminLayout />,
          children: [
            {
              element: (
                <OutletLayout Component={SubsidySwitchContextProvider} />
              ),
              children: [
                {
                  path: 'quote-summary',
                  element: <QuoteSummaryView />,
                },
              ],
            },
            {
              path: 'settings',
              element: <BreadcrumbLayout showToggleButtons />,
              children: [
                {
                  path: 'margins',
                  element: <AdjustmentsView adjustmentType="margin" />,
                },
                {
                  path: 'buffers',
                  element: <AdjustmentsView adjustmentType="buffer" />,
                },
              ],
            },
            {
              path: 'cost-basis',
              children: [
                { path: 'operations', element: <OperationsBasisView /> },
                {
                  path: 'inputs',
                  element: (
                    <InputsView
                      assignment={ASSIGNMENTS.DEVELOPER}
                      tableHeader="Developer Assigned Operation Inputs"
                    />
                  ),
                },
                { path: 'capex', element: <CapexBasisView /> },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default FarmRoutes;
